<template>
  <div>
    <div class="insert-plate mb-30">
      <h5>PER INIZIARE: SELEZIONA MARCA E MODELLO</h5>
      <p>per ottenere la Quotazione Storica del tuo veicolo</p>
    </div>
    <div class="tabs">
      <div
        class="tab bike"
        :class="{ active: activeTab === 'bike' }"
        v-on:click="setActiveTab('bike', 1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="31.346" viewBox="0 0 58 31.346">
          <path
            class="tab-icon"
            id="Moto_01"
            data-name="Moto 01"
            d="M21012,11353.342v-2h5.543a8.1,8.1,0,1,1,12.7-8.635h1.539a9.586,9.586,0,0,0-17.635-2.6.615.615,0,0,1-1.062-.619,10.856,10.856,0,0,1,9.365-5.4,10.629,10.629,0,0,1,2.479.291,4.042,4.042,0,0,1,2.27-2.11,3.464,3.464,0,0,1,3.119.878,9.464,9.464,0,0,0,8.068,1.549c.266-3.362,3.109-6.3,7.584-7.608a5.177,5.177,0,0,1,4.324.365,5.736,5.736,0,0,1,2.295,3.241l1.676-.608-1.48-4.457-4.287-1.434a.617.617,0,0,1-.387-.777.609.609,0,0,1,.777-.386l4.58,1.528a.631.631,0,0,1,.391.391l.988,2.982a3.245,3.245,0,0,1,2.945-1.893h1.48a.441.441,0,0,1,.439.438v5.621a.442.442,0,0,1-.439.444h-1.48a3.209,3.209,0,0,1-1.549-.4l1.861,5.6a7.925,7.925,0,0,1,1.924-.238,7.746,7.746,0,0,1,4.787,13.832H21069v2Zm43.24-2a7.745,7.745,0,0,1,1.7-13.192l-1.369-4.13c-1.168,2.021-6.244,10.8-6.346,10.982-1.707,2.978-2.945,5.129-7.477,5.129h-6.439a.436.436,0,0,1-.3-.116l-3.178-2.913h-1.592a8.092,8.092,0,0,1-2.887,4.24Zm.2-6.086a4.582,4.582,0,1,0,4.584-4.584,4.388,4.388,0,0,0-.92.095l1.5,4.532a.61.61,0,0,1-.391.776.6.6,0,0,1-.191.032.622.622,0,0,1-.586-.423l-1.5-4.511A4.6,4.6,0,0,0,21055.443,11345.257Zm-37.785-.354a4.791,4.791,0,0,0,9.047,2.2h-4.256a2.2,2.2,0,0,1,0-4.395h4.256a4.789,4.789,0,0,0-9.047,2.194Zm17.518-1.755a2.369,2.369,0,0,0,4.68.523h6.42a.447.447,0,0,0,.381-.217l4.07-6.89a.436.436,0,0,0-.381-.661h-5.018a.439.439,0,1,0,0,.878h4.252l-1.529,2.58h-5.631a.439.439,0,1,0,0,.878h5.113l-1.508,2.549h-6.139a2.369,2.369,0,0,0-4.711.359Z"
            transform="translate(-21011.5 -11322.496)"
            fill="#606060"
            stroke="rgba(0,0,0,0)"
            stroke-width="1"
          />
        </svg>
        <p>Moto</p>
      </div>
      <div
        class="tab car"
        :class="{ active: activeTab === 'car' }"
        v-on:click="goTo('https://quotazioni.quattroruote.it/')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="29.545" viewBox="0 0 80 29.545">
          <path
            class="tab-icon"
            id="Ico_Auto"
            data-name="Ico Auto"
            d="M434.307,124.5a6.322,6.322,0,0,1,4.2,11.048h5.732v1.6h-73.6v-1.6h10.786a6.324,6.324,0,1,1,8.4,0h40.278a6.322,6.322,0,0,1,4.2-11.048m-62.067,7.1-3.2-4.8v-8l1.6-1.6h4.8l1.6-1.6h-4.8l6.4-6.4,4.8-1.6h25.6l6.4,1.6,12.8,6.4h-4.8l-9.6-4.8h-28.8l-3.2,1.6-3.2,4.8h9.6v-4.8h3.2v4.8h12.8l-1.6-4.8h1.6l3.2,4.8h32l6.4,1.6,1.6,1.6h-3.2l-1.6,1.6h4.8v3.2h-4.8l6.4,1.6-1.6,4.8-3.2,1.6h-2.373a7.924,7.924,0,1,0-15.119,0H393.186a7.923,7.923,0,1,0-15.119,0H372.24Zm62.067-3.9a3.123,3.123,0,1,0,3.124,3.123,3.126,3.126,0,0,0-3.124-3.123m0,1.6a1.524,1.524,0,1,0,1.524,1.523,1.525,1.525,0,0,0-1.524-1.523m-48.681,0a1.524,1.524,0,1,0,1.524,1.523,1.525,1.525,0,0,0-1.524-1.523m0-1.6a3.123,3.123,0,1,0,3.124,3.123,3.124,3.124,0,0,0-3.124-3.123"
            transform="translate(-369.04 -107.605)"
            fill="#606060"
            fill-rule="evenodd"
          />
        </svg>
        <p>Auto</p>
      </div>
      <div
        class="tab commercial-vehicle"
        :class="{
          active: activeTab === 'commercial-vehicle',
        }"
        v-on:click="goTo('https://quotazioni.quattroruote.it/')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="89" height="34.103" viewBox="0 0 89 34.103">
          <path
            class="tab-icon"
            id="Ico_V._Comm."
            data-name="Ico V. Comm."
            d="M258.85,646.055a5.988,5.988,0,0,1,4.224,10.234h6.144v1.745H185.453v-1.745h7.765a5.989,5.989,0,1,1,8.447,0h52.963a5.988,5.988,0,0,1,4.223-10.234m-73.4,4.053-1.745-3.49v-3.491h5.234l-3.49-1.745v-3.49h24.431l-1.745-1.745H185.453l1.745-10.471,1.745-1.745h55.843l3.49,1.745,10.471,8.725h-3.491l-6.98-6.98H236.061v5.235l1.745,1.745,17.451,1.746h6.98l6.982,3.49,1.745,1.745-1.745,1.745v1.745h1.745l1.745,1.745v3.491l-3.49,3.49h-2.79a7.734,7.734,0,1,0-15.155,0H205.019a7.735,7.735,0,1,0-15.255-.617Zm73.4.659a1.278,1.278,0,1,0,1.278,1.277,1.279,1.279,0,0,0-1.278-1.277m-61.41,0a1.278,1.278,0,1,0,1.278,1.277,1.279,1.279,0,0,0-1.278-1.277m61.41-1.745a3.023,3.023,0,1,0,3.024,3.022,3.023,3.023,0,0,0-3.024-3.022m-61.41,0a3.023,3.023,0,1,0,3.024,3.022,3.024,3.024,0,0,0-3.024-3.022"
            transform="translate(-183.708 -623.931)"
            fill="#606060"
            fill-rule="evenodd"
          />
        </svg>
        <p>Veicolo Commerciale</p>
      </div>
    </div>
    <insert-plate
      :vehicle_type="vehicleType"
      :quotation_type="quotationType"
      @plate-change="onPlateChange"
    ></insert-plate>
    <select-storic-dropdown
      :vehicle_type="vehicle_type"
      :is-logged="isLogged"
      :myBike="myBike"
      :quotation_type="quotation_type"
      :is-plate-valid="initialPlate.length === 7"
    ></select-storic-dropdown>
  </div>
</template>

<script>
export default {
  name: 'StoricSelectContainer',
  props: {
    initial_plate: {
      type: String,
      default: '',
    },
    vehicle_type: {
      type: Number,
      required: true,
    },
    quotation_type: {
      type: String,
      required: true,
    },
    loggedUser: {
      type: Object,
      required: false,
    },
    myBike: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  computed: {
    isLogged() {
      return !!this.loggedUser;
    },
  },
  data() {
    return {
      activeTab: 'bike',
      vehicleType: this.vehicle_type,
      quotationType: this.quotation_type,
      initialPlate: this.initial_plate,
    };
  },
  methods: {
    setActiveTab(tab, type) {
      this.activeTab = tab;
      this.vehicleType = type;
      this.$emit('update-vehicle-type', type);
      sessionStorage.setItem('vehicle_type', type);
    },
    goTo(url) {
      window.open(url, '_blank');
    },
    onPlateChange(value) {
      this.initialPlate = value;
    },
  },
  mounted() {
    const storedVehicleType = sessionStorage.getItem('vehicle_type');
    if (this.quotationType === 'nominale' && storedVehicleType !== null) {
      this.$emit('update-vehicle-type', parseInt(storedVehicleType));
      if (parseInt(storedVehicleType) === 1) {
        this.vehicleType = 1;
        this.activeTab = 'bike';
      } else if (parseInt(storedVehicleType) === 2) {
        this.vehicleType = 2;
        this.activeTab = 'commercial-vehicle';
      }
    } else if (this.quotationType === 'storica') {
      this.vehicleType = 1;
      this.activeTab = 'bike';
    }
  },
};
</script>

<style scoped>
.pe-none {
  pointer-events: none;
}
.mb-30 {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/StoricSelectContainer.vue